import React from 'react'
import { Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { routesDef } from '../../../../config/routes'
import { truncate } from '@ztechapps/common.utils'
import { ProductSize1Image } from '@ztechapps/product.webui'

export const BoardCard = ({ board }) => {
  const count = board?.items?.length ?? 0
  return (
    <Card>
      {/*<Image url={board?.icon} />*/}
      <ProductSize1Image url={board?.icon} />

      <Card.Body>
        <Link to={routesDef.AccountBoardsDetailsPage.altPath({ _id: board?._id })}>
          <Card.Title as="h6">{board?.name}</Card.Title>
        </Link>
        <Card.Text>{truncate(board?.remarks, 250)}</Card.Text>
      </Card.Body>
      <Card.Footer>
        <Card.Text>
          {count} {count > 1 ? 'products' : 'product'}
        </Card.Text>
      </Card.Footer>
    </Card>
  )
}
